var messages = {
  placeholder: 'Please enter',
  size: 'Font Size',
  color: 'Font Color',
  background: 'Background Color',
  bold: 'Bold',
  italic: 'Italic',
  underline: 'Underline',
  strike: 'Strikethrough',
  indent: {
    '-1': 'Forward Indent',
    '+1': 'Backward Indent'
  },
  list: {
    ordered: 'Ordered List',
    bullet: 'Unordered List'
  },
  align: 'Align',
  link: 'Link',
  image: 'Image',
  video: 'Video',
  clean: 'Clear Format'
};
export default messages;